export default "__VITE_ASSET__Bs$CdsMj__"